import { useContext } from 'react';
import { AmbientMusicContext, IAmbientMusicContext } from './AmbientMusicProvider';

// light wrapper around AmbientMusicProvider so we can use it as a custom hook
const useAmbientMusic = () => {
    return useContext(AmbientMusicContext) as IAmbientMusicContext;
}

export default useAmbientMusic;